export const button = {
  yes: 'OK',
  no: 'キャンセル',
  save: '保存',
  close: '閉じる',
  create: '新規作成',
  update: '更新',
  edit: '編集',
  delete: '削除',
  detail: '詳細',
  login: 'ログイン',
  logout: 'ログアウト',
  search: '検索',
  clear: 'クリア',
  cancel: 'キャンセル',
  export: 'エクスポート'
};
